<template>
  <div class="place-items-start gap-24 mt-8">
    <a
      v-for="({ media, link }, index) in medias"
      :key="`media-${index}`"
      :href="link"
      target="_blank"
    >
      <p-icon color="fg-secondary" :icon="media" />
    </a>
  </div>
</template>

<script setup lang="ts">
const medias = [
  {
    media: 'youtube',
    link: 'https://www.youtube.com/c/Paribu',
  },
  {
    media: 'twitter',
    link: 'https://twitter.com/paribucom',
  },
  {
    media: 'linkedin',
    link: 'https://www.linkedin.com/company/paribu/',
  },
  {
    media: 'instagram',
    link: 'https://www.instagram.com/paribucom/',
  },
  {
    media: 'facebook',
    link: 'https://www.facebook.com/paribucom',
  },
]
</script>
